/* main react */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

/* reducer, selector, action */
import { signInDSAStart } from '../../_actions/authentication.actions';
import Spinner from '../../_components/spinner/spinner.component';

const DSALogin = (props) => {

  const {
    signInDSAStart,
  } = props;
  const history = useHistory();

  useEffect(() => {
    signInDSAStart({history});
  });

  return (
    <div className='w-100 text-center'>
      <h1 className='mb-0'>DSA Login - please wait...</h1>
      <Spinner />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  signInDSAStart: (payload) => dispatch(signInDSAStart(payload)),
});

export default connect(null, mapDispatchToProps)(DSALogin);
